import {ColumnMain} from "../column-main";
import {Column} from "../column";
import {Trans} from "@lingui/macro";
import React from "react";
import { Tag } from 'antd';



const DeliveryCargoListModel = (mode:any) : ColumnMain => {

    const columns : Array<Column> = new Array();
    columns.push({key:'rollNumber', filter:true, width: 150, sorter:true,title:<Trans>Roll Number</Trans>});
    columns.push({key:'deliveryNoteNumber', filter:true, width: 200, sorter:true,title:<Trans>Delivery Note Number</Trans>});
    columns.push({key:'item.fifoNumber', width: 200, dataIndex: ['item', 'fifoNumber'], filter:true, sorter:true,title:<Trans>Fifo number</Trans>});
    columns.push({key:'supplier.name', width: 200, dataIndex: ['supplier', 'name'], filter:true, sorter:true,title:<Trans>Supplier</Trans>});
    columns.push({key:'weight', width: 150, filter:true, sorter:true,title:<Trans>Weight</Trans>});
    columns.push({key:'remark', width: 150, filter:true, sorter:true,title:<Trans>Remark</Trans>});
    columns.push({key:'updatedDate', width: 150, dateFilter:true, sorter:true,title:<Trans>Updated Date</Trans>});
    columns.push({key:'updatedBy', width: 150, dateFilter:true, sorter:true,title:<Trans>Updated By</Trans>});
    columns.push({key:'createdDate', width: 150, dateFilter:true, sorter:true,title:<Trans>Created Date</Trans>,direction:"desc"});
    columns.push({key:'createdBy', width: 150, dateFilter:true, sorter:true,title:<Trans>Created By</Trans>});

    return{
        columns:columns,
        url:"/resource/stock/can-be-used"
    };

}

export default DeliveryCargoListModel;
